const { default: styled } = require("styled-components");

export const DashboardWrapper = styled.section`
  margin-left: 252px;
  padding: 4rem 8rem;
`;

export const Footer = styled.footer`
  display: flex;
  gap: 2rem;
`;

export const Header = styled.header`
  width: 100%;
  text-align: left;
  padding-bottom: 10px;
  border-bottom: 1px solid #979797;
`;

export const DetailCardsWrapper = styled.section`
  display: flex;
  padding-bottom: 20px;
  padding-top: 50px;
`;

export const DetailCard = styled.div`
  border: 1px solid #436ab2;
  padding: 20px 15px;
  border-radius: 8px;
  margin-right: 20px;
  width: 100%;
  max-width: 200px;
  background: #e7f2ff;
  height: 150px;
`;

export const InnerDiv = styled.div`
  align-items: center;
  padding-bottom: 20px;
`;
